import {DIALOG_STATE_NAME, DialogState} from "./dialog";
import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';

export const selectDialogState: MemoizedSelector<object, DialogState> = createFeatureSelector<DialogState>(DIALOG_STATE_NAME);

export const selectLast: MemoizedSelector<object, any> = createSelector(
  selectDialogState,
  (state: DialogState) => state.last
);

export const selectCurrent: MemoizedSelector<object, any> = createSelector(
  selectDialogState,
  (state: DialogState) => state.current
);

export const selectData: MemoizedSelector<object, unknown> = createSelector(
  selectDialogState,
  (state: DialogState): unknown => state.data
);
